import axios from "axios";
import { IAPIResponse } from "../../types/IAPIResponse";
import { ApplicationTypeDto } from "../../types/Applicant/ApplicationTypeDto";
import {
  LahzaRequestDTO,
  LahzaRequestPayDTO,
  LahzaResponseDTO,
} from "../../types/Applicant/LahzaRequestDto";

export class AvailableApplicationsAPI {
  async GetAll(): Promise<IAPIResponse<ApplicationTypeDto[]>> {
    const response = await axios.get<IAPIResponse>(
      "paymenthub/get-available-applications/"
    );
    let templetes: IAPIResponse<ApplicationTypeDto[]> = response.data;
    return Promise.resolve(templetes);
  }

  async GetInitTransaction(
    result: LahzaRequestDTO
  ): Promise<IAPIResponse<LahzaResponseDTO>> {
    const response = await axios.post<IAPIResponse>(
      "/paymenthub/get-lahza-url",
      result
    );
    let templetes: IAPIResponse<LahzaResponseDTO> = response.data;
    return Promise.resolve(templetes);
  }

  async GetInitTransactionForNewIntake(
    data: LahzaRequestPayDTO
  ): Promise<IAPIResponse<LahzaResponseDTO>> {
    const response = await axios.post<IAPIResponse>(
      "/paymenthub/get-lahza-url-pay",
      data
    );
    let templetes: IAPIResponse<LahzaResponseDTO> = response.data;
    return Promise.resolve(templetes);
  }
}
